<template>
  <v-dialog v-model="value" persistent max-width="900px">
    <material-card color="primary" :title="title">
      <v-form ref="form" v-model="validForm">
        <v-container grid-list-md>
          <v-layout wrap>

            <v-flex xs12 sm6 md6>
              <v-text-field
                label="Search on Meddra"
                v-model="search_term"
              ></v-text-field>
            </v-flex>

            <v-flex xs12 sm3 md3>
              <v-text-field
                label="Meddra PT id"
                disabled
                v-model="item.meddra_pt_id"
              ></v-text-field>
            </v-flex>

          
            <v-flex xs12 s3 md3>
              <v-text-field
                label="AE Lower Level Term"
                v-model="item.meddra_ae_lower_level_term"
                disabled
              ></v-text-field>
            </v-flex>

            <v-flex xs12 sm3 md3>
              <v-text-field
                label="AE Preferred Term"
                v-model="item.meddra_ae_preferred_term"
                disabled
              ></v-text-field>
            </v-flex>

            <v-flex xs12 sm7 md7 v-if="!chooseSoc">
              <v-text-field
                label="System organ class"
                v-model="item.meddra_system_organ_class"
                disabled
              ></v-text-field>
            </v-flex>


             <v-flex xs12 sm7 md7 v-if="chooseSoc">
                <v-select
                  clearable
                  md4
                  v-model="choosedSoc"
                  :items="socs"
                  label="System organ class"
                  item-value="id"
                  item-text="label"
                  return-object
                  @change="confirmSoc"
              ></v-select>

            </v-flex>
            

            <v-flex xs10 sm1 md1>
                <v-btn  flat icon color="pink" @click="editSoc">
                <v-icon color="primary">mdi-pencil</v-icon>
              </v-btn>
            </v-flex>


              <v-flex xs12 sm1 md1>
              <v-text-field
                label="Version"
                disabled
                v-model="item.meddra_version"
              ></v-text-field>
            </v-flex>


            
          </v-layout>
        </v-container>
      </v-form>

      <v-flex xs12>
        <v-alert :value="this.sae.meddra_version && this.item.meddra_version && this.sae.meddra_version != this.item.meddra_version" type="warning" dismissible outline>
          <b>Attention please, the version of MedDRA has changed : {{this.sae.meddra_version}} => {{this.item.meddra_version}}</b>
        </v-alert>
      </v-flex>

      

      <v-flex xs12 text-xs-right>
        <v-btn class="mx-1 font-weight-light" color="success" @click="close()"
          >Close</v-btn
        >

        <v-btn
          class="mx-1 font-weight-light"
          color="purple"
          :disabled="!checkSave()"
          @click="save()"
          >Save</v-btn
        >
      </v-flex>
    </material-card>
  </v-dialog>
</template>

<script>
import { upsert, meddra, meddraById, getDetail, getSocs } from "@/api/adverse_event";
import validators from "@/utils/validators";

export default {
  inheritAttrs: false,
  props: {
    value: Boolean,
    sae: Object
  },
  data() {
    return {
      validForm: true,
      validators,
      search_term: null,
      item: {
        meddra_pt_id: null,
        meddra_llt_id: null,
        meddra_ae_lower_level_term: null,
        meddra_ae_preferred_term: null,
        meddra_system_organ_class: null,
        meddra_version: null
      },
      loadedSae: {},
      chooseSoc: false,
      choosedSoc: '',
      socs: [],
      checkMeddraVersion: false
    };
  },
  mounted() {
  },
  watch: {
    value(v) {

      // get db value
      if (v) {
        getDetail(this.sae.id).then( data => {
          this.loadedSae = data;
          if (!data.meddra_pt_id) {
            this.$refs.form.reset();
            this.getData().then( d => {
              this.search_term = this.sae.ae_verbatim_reported;
            });
          } else {
            this.item.meddra_llt_id = this.loadedSae.meddra_llt_id;
            this.item.meddra_pt_id = this.loadedSae.meddra_pt_id;
            this.item.meddra_ae_lower_level_term = this.loadedSae.meddra_ae_lower_level_term;
            this.item.meddra_ae_preferred_term = this.loadedSae.meddra_ae_preferred_term;
            this.item.meddra_system_organ_class = this.loadedSae.meddra_system_organ_class;
            this.item.meddra_version = this.loadedSae.meddra_version;
            this.search_term = null;

            if (!this.item.meddra_ae_lower_level_term) {
              this.getDataById();
            }
          }
          this.checkMeddraVersion = true;
        });
      }

    },
    search_term(v) {
      if (v) {
        this.chooseSoc = false;
        this.getData();
      }
    },
    chooseSoc(v) {
      if (this.loadedSae.meddra_pt_id) {
        getSocs(this.loadedSae.meddra_pt_id).then( data => {
          this.socs = data.categories;
        });
      }
    },
    choosedSoc(v) {
      this.loadedSae.meddra_system_organ_class = v.label
    }
  },
  computed: {
    title() {
      return "Meddra for SAE " + this.sae.cin;
    }
  },
  methods: {
    getData() {
      return meddra(this.search_term).then(data => {
        if (data.pt_code) {
          this.loadedSae.meddra_llt_id = this.item.meddra_llt_id = data.llt_code;
          this.loadedSae.meddra_pt_id = this.item.meddra_pt_id = data.pt_code;
          this.loadedSae.meddra_ae_lower_level_term = this.item.meddra_ae_lower_level_term = data.llt_name;
          this.loadedSae.meddra_ae_preferred_term = this.item.meddra_ae_preferred_term = data.pt_name;
          this.loadedSae.meddra_system_organ_class = this.item.meddra_system_organ_class = data.soc_name;
          this.loadedSae.meddra_version = this.item.meddra_version = data.meddra_version;
        } else {
          this.loadedSae.meddra_llt_id = this.item.meddra_llt_id = null;
          this.loadedSae.meddra_pt_id = this.item.meddra_pt_id = null;
          this.loadedSae.meddra_ae_lower_level_term = this.item.meddra_ae_lower_level_term = null;
          this.loadedSae.meddra_ae_preferred_term = this.item.meddra_ae_preferred_term = null;
          this.loadedSae.meddra_system_organ_class = this.item.meddra_system_organ_class = null;
          this.loadedSae.meddra_version = this.item.meddra_version = null;
        }
      });
    },
    getDataById() {
      return meddraById(this.loadedSae.meddra_pt_id).then(data => {
        if (data.pt_code) {
          this.loadedSae.meddra_llt_id = this.item.meddra_llt_id = data.llt_code;
          this.loadedSae.meddra_pt_id = this.item.meddra_pt_id = data.pt_code;
          this.loadedSae.meddra_ae_lower_level_term = this.item.meddra_ae_lower_level_term = data.llt_name;
          this.loadedSae.meddra_ae_preferred_term = this.item.meddra_ae_preferred_term = data.pt_name;
          this.loadedSae.meddra_system_organ_class = this.item.meddra_system_organ_class = data.soc_name;
          this.loadedSae.meddra_version = this.item.meddra_version = data.meddra_version;
        } else {
          this.loadedSae.meddra_ltt_id = this.item.meddra_llt_id = null;
          this.loadedSae.meddra_pt_id = this.item.meddra_pt_id = null;
          this.loadedSae.meddra_ae_lower_level_term = this.item.meddra_ae_lower_level_term = null;
          this.loadedSae.meddra_ae_preferred_term = this.item.meddra_ae_preferred_term = null;
          this.loadedSae.meddra_system_organ_class = this.item.meddra_system_organ_class = null;
          this.loadedSae.meddra_version = this.item.meddra_version = null;
        }
      });
    },
    editSoc() 
    {
      this.chooseSoc = true;
    },
    confirmSoc() {
      //this.chooseSoc = false;
    },
    close() {
      //this.$store.dispatch("app/closePregnancyDialog");
      this.chooseSoc = false;
      this.$emit("input", false);
    },
    checkSave() {
      return this.item.meddra_pt_id
    },
    save() {
      upsert(this.loadedSae)
        .then(data => {
          this.$store.dispatch("app/openSnackbar", {
            message: "Meddra section updated correctly",
            color: "success"
          });

          this.$emit('update:sae', this.loadedSae)
        })
        .catch(e => {
          this.$store.dispatch("app/openSnackbar", {
            message:
              "An Error occurred during the SAE Meddra section. " +
              e.response.data.message,
            color: "error"
          });
        });
    }
  }
};
</script>

<style>
#core-view {
  padding-bottom: 100px;
}
</style>
